// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Atom_Cta from "../../atom/Atom_Cta.bs.js";
import * as Atom_Text from "../../atom/Atom_Text.bs.js";
import * as Atom_Column from "../../atom/Atom_Column.bs.js";
import * as Atom_Cta_Ds from "../../atom/Atom_Cta_Ds.bs.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Type_String from "../../../type/Type_String.bs.js";
import * as Type_Teaser from "../../../type/Type_Teaser.bs.js";
import * as Particle_Screen_Ds from "../../particle/Particle_Screen_Ds.bs.js";
import * as Organism_Teaser_Title from "./Organism_Teaser_Title.bs.js";
import * as Organism_Teaser_Subtitle from "./Organism_Teaser_Subtitle.bs.js";
import * as Particle_Screen_Constants from "../../particle/Particle_Screen_Constants.bs.js";
import * as Organism_Teaser_Animated_Title from "./Organism_Teaser_Animated_Title.bs.js";
import * as Organism_Teaser_Css_Identifier from "./Organism_Teaser_Css_Identifier.bs.js";

var landscapeGenreRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [
      CssJs.position(CssJs.absolute),
      CssJs.top(CssJs.pct(50)),
      CssJs.left(CssJs.pct(50)),
      CssJs.transform(CssJs.translate({
                NAME: "percent",
                VAL: -50
              }, {
                NAME: "percent",
                VAL: -50
              }))
    ]);

function Organism_Teaser_Legend(Props) {
  var id = Props.id;
  var genre = Props.genre;
  var genreStyle = Props.genreStyle;
  var justifyContent = Props.justifyContent;
  var subtitle = Props.subtitle;
  var subtitleStyle = Props.subtitleStyle;
  var title = Props.title;
  var titleStyle = Props.titleStyle;
  var teaserTemplate = Props.teaserTemplate;
  var genre$1;
  if (genre !== undefined && genreStyle !== undefined) {
    var url = genre.url;
    var label = genre.label;
    if (url !== undefined) {
      genre$1 = React.createElement(Atom_Cta.Link.make, {
            href: Curry._1(Type_String.Program.Genre.Url.toString, url),
            label: Curry._1(Type_String.Program.Genre.Label.toString, label),
            style: genreStyle
          });
    } else {
      var ctaStyle = Atom_Cta_Ds.make(genreStyle);
      genre$1 = React.createElement(Atom_Text.make, {
            children: Curry._1(Type_String.Program.Genre.Label.toString, label),
            style: ctaStyle.textStyle
          });
    }
  } else {
    genre$1 = null;
  }
  var content;
  var exit = 0;
  var title$1;
  var subtitle$1;
  var style;
  if (title !== undefined) {
    switch (title.TAG | 0) {
      case /* Displayed */0 :
          var title$2 = title._0;
          if (subtitle !== undefined) {
            switch (subtitle.TAG | 0) {
              case /* Normal */0 :
                  content = Caml_option.some(React.createElement(React.Fragment, undefined, React.createElement(Organism_Teaser_Title.make, {
                                title: title$2,
                                style: titleStyle,
                                identifier: Organism_Teaser_Css_Identifier.title
                              }), React.createElement(Organism_Teaser_Subtitle.make, {
                                identifier: Organism_Teaser_Css_Identifier.subtitle,
                                subtitle: subtitle._0,
                                style: subtitleStyle
                              }), genre$1));
                  break;
              case /* SubtitleAsTitle */1 :
                  title$1 = title$2;
                  subtitle$1 = subtitle._0;
                  style = subtitle._1;
                  exit = 2;
                  break;
              case /* HoverOnly */2 :
                  content = undefined;
                  break;
              
            }
          } else {
            content = Caml_option.some(React.createElement(React.Fragment, undefined, teaserTemplate !== 8 ? React.createElement(Organism_Teaser_Title.make, {
                            title: title$2,
                            style: titleStyle,
                            identifier: Organism_Teaser_Css_Identifier.title
                          }) : React.createElement(Organism_Teaser_Animated_Title.make, {
                            id: id,
                            title: title$2,
                            style: titleStyle
                          }), genre$1));
          }
          break;
      case /* AccessibilityOnly */1 :
          if (subtitle !== undefined) {
            switch (subtitle.TAG | 0) {
              case /* SubtitleAsTitle */1 :
                  title$1 = title._0;
                  subtitle$1 = subtitle._0;
                  style = subtitle._1;
                  exit = 2;
                  break;
              case /* Normal */0 :
              case /* HoverOnly */2 :
                  content = undefined;
                  break;
              
            }
          } else {
            content = undefined;
          }
          break;
      case /* HoverOnly */2 :
          exit = 1;
          break;
      
    }
  } else {
    exit = 1;
  }
  switch (exit) {
    case 1 :
        if (subtitle !== undefined) {
          switch (subtitle.TAG | 0) {
            case /* SubtitleAsTitle */1 :
                content = Caml_option.some(React.createElement(React.Fragment, undefined, React.createElement(Organism_Teaser_Subtitle.make, {
                              identifier: Organism_Teaser_Css_Identifier.subtitle,
                              subtitle: subtitle._0,
                              style: Type_Teaser.getSubtitleDsStyle(titleStyle, subtitleStyle, subtitle._1),
                              kind: "h3"
                            }), genre$1));
                break;
            case /* Normal */0 :
            case /* HoverOnly */2 :
                content = undefined;
                break;
            
          }
        } else {
          content = undefined;
        }
        break;
    case 2 :
        content = Caml_option.some(React.createElement(React.Fragment, undefined, React.createElement(Organism_Teaser_Title.make, {
                      title: title$1,
                      style: undefined,
                      identifier: Organism_Teaser_Css_Identifier.title
                    }), React.createElement(Organism_Teaser_Subtitle.make, {
                      identifier: Organism_Teaser_Css_Identifier.subtitle,
                      subtitle: subtitle$1,
                      style: Type_Teaser.getSubtitleDsStyle(titleStyle, subtitleStyle, style),
                      kind: "h3"
                    }), genre$1));
        break;
    
  }
  var rules = teaserTemplate !== 8 ? undefined : Caml_option.some(landscapeGenreRules);
  if (content === undefined) {
    return null;
  }
  var tmp = {
    children: Caml_option.valFromOption(content),
    width: Particle_Screen_Constants.oneHundredPctWidth
  };
  if (justifyContent !== undefined) {
    tmp.justifyContent = Caml_option.valFromOption(justifyContent);
  }
  if (rules !== undefined) {
    tmp.rules = Caml_option.valFromOption(rules);
  }
  return React.createElement(Atom_Column.make, tmp);
}

var make = Organism_Teaser_Legend;

export {
  landscapeGenreRules ,
  make ,
}
/* landscapeGenreRules Not a pure module */
